/* eslint object-property-newline: "off" */
const map = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ñ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ő: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ű: 'u',
  ý: 'y',
  ÿ: 'y',
}

/**
 * Transliterate.
 * @param {string} str - The param to transliterate
 * @returns {string} - Returns is a converted str
 */
export default function transliterate(str) {
  return `${str}`
    .toLocaleLowerCase()
    .replace(/[^a-z0-9\s_-]/g, c => map[c] || c)
}
